<div id="app-greenid" *ngIf="model$|async; let model">
  <ng-container *ngIf="model.overallStatus !== 'ERROR'">
    <div class="d-flex item not-verified flex-column flex-fill" *ngIf="!model.verified" (click)="onStartClick(model)">
      <div class="d-flex flex-row flex-fill">
        <div class="flex-fill align-items-center d-flex">
          <div class="greenid-icon-wrapper">
            <mat-icon class="mr-2">fingerprint</mat-icon>
          </div>
          Start verification
        </div>
        <mat-icon class="animate__animated animate__headShake animate__delay-1s">error_outline</mat-icon>
      </div>
      <mat-progress-bar *ngIf="isLoading$ | async" mode="indeterminate"></mat-progress-bar>
    </div>
    <div class="d-flex item verified flex-row align-items-center" *ngIf="model.verified">
      <div class="flex-fill align-items-center d-flex">
        <div class="greenid-icon-wrapper">
          <mat-icon class="mr-2">fingerprint</mat-icon>
        </div>
        Your identity has been verified
      </div>
      <mat-icon class="verified-icon animate__animated animate__rubberBand animate__delay-1s">verified</mat-icon>
    </div>
  </ng-container>

  <ng-container *ngIf="model.overallStatus === 'ERROR'">
    <div class="alert alert-danger">
      <div class="d-flex flex-column">
        <div class="mb-0">
          Could not load GreenID successfully.
        </div>
        <ng-container *ngIf="model.errorList.length > 0">
          <div *ngIf="data.errorList; let list" class="mt-2">
            <ul>
              <li *ngFor="let i of list">{{i}}</li>
            </ul>
          </div>
        </ng-container>
      </div>
    </div>
  </ng-container>
</div>